export default class Links {
  constructor() {
    this.smoothScroll = true;
    this.externalBlank = true;
  }

  init() {
    this.setSmoothScroll(500, 120);
    this.openExternalLinksBlank();
  }

  /**
   * Animates the body scrollTop when clicking on a link
   * @example a[data-scroll-to=".other-element"] || a[data-scroll-to="next-row"]
   * @param {int} speed
   * @param {int} offset
   */
  setSmoothScroll(speed = 500, offset = 0, mindHeader = true) {
    if (!this.smoothScroll) {
      return;
    }

    $('a[href*="#"]', $('body'))
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('.location-link')
      .not('[data-show]')
      .filter(function onlyCurrentPageAnchors() {
        const locationHostname = window.location.hostname;
        const locationPath = window.location.pathname.replace(/^\//, '');
        const locationSearch = window.location.search;

        const linkHostname = this.hostname || locationHostname;
        const linkPath = (this.pathname || '').replace(/^\//, '');
        const linkSearch = this.search || '';

        const hasHash = typeof this.hash === 'string' && this.hash.startsWith('#') && this.hash.length > 1;
        const sameHost = linkHostname === locationHostname;
        const samePath = (linkPath || locationPath) === locationPath;
        const sameSearch = linkSearch === '' || linkSearch === locationSearch;

        return hasHash && sameHost && samePath && sameSearch;
      })
      .on('click', function scrollToTarget(e) {
        if ($(this).hasClass('nav-link') && (this.href.split('#')[0] !== window.location.href.split('#')[0])) {
          return;
        }

        e.preventDefault();

        const target = $(this.hash);
        const offsetScroll = Links.getOffsetScroll(offset, mindHeader);

        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - offsetScroll,
          }, speed, () => {
            window.history.pushState({}, '', this.hash);
          });
        }
      });
  }

  static scrollTo(target, speed = 300, offset = 0, mindHeader = true) {
    const offsetScroll = Links.getOffsetScroll(offset, mindHeader);
    const targetElement = $(target);

    $('html, body').animate({
      scrollTop: targetElement.offset().top - offsetScroll,
    }, speed);
  }

  static getOffsetScroll(offset, mindHeader) {
    let offsetScroll = offset;

    if (mindHeader) {
      const header = $('.header');
      if (header.css('position') === 'fixed' || header.css('position') === 'sticky') {
        offsetScroll += header.height();
      }
    }

    return offsetScroll;
  }

  /**
   * Opens links that aren't in our multisite network in a new tab
   */
  openExternalLinksBlank() {
    if (!this.externalBlank) {
      return;
    }

    $('a')
      .not('[href*="#"]')
      .each((index, el) => {
        if (el.hostname.length
          && (el.hostname !== window.location.hostname && !siteUrls.indexOf(el.hostname) >= 0)) {
          $(el).attr('target', '_blank');
        }
      });
  }
}

$(document).ready(() => {
  new Links().init();
});
